import React, { Fragment, useState, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import axios from 'axios';
import xss from 'xss';

import { useTheme } from '@material-ui/core/styles';
import useMediaQuery from '@material-ui/core/useMediaQuery';
import CircularProgress from '@material-ui/core/CircularProgress';
import Tooltip from '@material-ui/core/Tooltip';
import IconButton from '@material-ui/core/IconButton';

import EditIcon from '@material-ui/icons/EditSharp';

import pushToGTM, { RENAME_DESIGN_GA4_TAG } from '../../../../utils/analytics/gtm';
import userSlice from '../../../../redux/slices/userSlice';
import { useStyles } from './styles';
import TextField from '../../../TextField';
import Button from '../../../Button';
import Dialog from '../../../Dialog';
import { useTranslation } from 'react-i18next';

const DesignNameDialog = () => {
	const { t } = useTranslation();
	const classes = useStyles();
	const theme = useTheme();
	const [open, setOpen] = useState(false);
	const [isLoading, setIsLoading] = useState(false);
	const fullScreen = useMediaQuery(theme.breakpoints.down('xs'));
	const myDesign = useSelector(state => state.selectedDesign.myDesign);
	const progressActive = useSelector(state => state.tabbar.progressActive);
	const [name, setName] = useState(myDesign.name);
	const dispatch = useDispatch();

	useEffect(() => {
		setName(myDesign.name);
	}, [myDesign.name]);

	const handleClose = () => {
		setOpen(false);
		setName(myDesign.name);
	};

	const handleSetName = event => {
		setName(event.target.value);
	};

	const handleNameUpdate = () => {
		if (!name.trim() || myDesign.name === name) {
			setOpen(false);
			return;
		}

		pushToGTM(RENAME_DESIGN_GA4_TAG);

		setIsLoading(true);

		setTimeout(() => {
			axios
				.get('api/myDesigns/update/name?value=' + xss.filterXSS(name) + '&id=' + xss.filterXSS(myDesign.id))
				.then(response => {
					const newMyDesign = response.data;
					dispatch(
						userSlice.actions.updateMyDesignName({
							id: myDesign.id,
							name: newMyDesign.name,
							dateModified: newMyDesign.dateModified
						})
					);
				})
				.catch(() => {
					console.error('Error: updating design ' + myDesign.id);
				});

			setIsLoading(false);
			setOpen(false);
		}, 1200);
	};

	return (
		<Fragment>
			<Tooltip title={t('components.summary.designNameDialog.tooltipTitle')}>
				<IconButton
					aria-label="Edit design name"
					size="small"
					disabled={progressActive}
					onClick={() => {
						setOpen(true);
					}}>
					<EditIcon fontSize="small" />
				</IconButton>
			</Tooltip>

			<Dialog
				open={open}
				handleClose={handleClose}
				fullScreen={fullScreen}
				fullWidth
				maxWidth={'sm'}
				title={t('components.summary.designNameDialog.title')}
				content={
					<div className={classes.contentContainer}>
						<TextField
							id="mydesign-name-textfield"
							color="secondary"
							fullWidth
							label={t('components.summary.designNameDialog.title')}
							onChange={handleSetName}
							value={name}
							inputProps={{ maxLength: 60 }}
						/>
					</div>
				}
				actions={
					<div className={classes.buttonWrapper}>
						<Button color="primary" bold disabled={isLoading || !name.trim()} onClick={handleNameUpdate}>
							{t('components.summary.designNameDialog.button')}
						</Button>

						{isLoading && <CircularProgress size={24} className={classes.buttonProgress} />}
					</div>
				}
			/>
		</Fragment>
	);
};

export default DesignNameDialog;
